import { cva as e } from "class-variance-authority";
// src/design/description-list/style.ts
var t = e("w-full"), n = e(["rounded-lg overflow-hidden"], { variants: {
	variant: {
		divider: "",
		none: ""
	},
	bordered: {
		true: "border",
		false: ""
	},
	flush: {
		true: "",
		false: "px-3 py-2"
	},
	color: {
		none: "bg-transparent border-border",
		default: "bg-muted border-border",
		primary: "bg-secondary border-secondary",
		danger: "bg-destructive/10 border-destructive/30",
		success: "bg-success/10 border-success/30",
		warning: "bg-warning/10 border-warning/30",
		info: "bg-info/10 border-info/30",
		discovery: "bg-discovery/10 border-discovery/30"
	}
} }), r = e("", {
	variants: { variant: {
		divider: "divide-y divide-border",
		none: "divide-transparent"
	} },
	defaultVariants: { variant: "divider" }
}), i = e("grid grid-cols-4 gap-3 px-4 py-3 items-start"), a = e("font-semibold text-foreground col-span-1", {
	variants: { size: {
		sm: "text-xs",
		md: "text-sm",
		lg: "text-base"
	} },
	defaultVariants: { size: "md" }
}), o = e("col-span-3 break-words", {
	variants: {
		size: {
			sm: "text-xs",
			md: "text-sm",
			lg: "text-base"
		},
		muted: {
			true: "text-muted-foreground",
			false: "text-foreground"
		}
	},
	defaultVariants: {
		size: "md",
		muted: !1
	}
}), s = e("space-y-0"), c = e("px-4 pt-3 pb-2 text-xs font-semibold text-foreground uppercase tracking-wider"), l = e("divide-y divide-border"), u = () => ({
	root: t,
	card: n,
	cardInner: r,
	row: i,
	term: a,
	details: o,
	section: s,
	sectionTitle: c,
	sectionContent: l
});
export { r as descriptionListCardInnerStyles, n as descriptionListCardStyles, o as descriptionListDetailsStyles, t as descriptionListRootStyles, i as descriptionListRowStyles, l as descriptionListSectionContentStyles, s as descriptionListSectionStyles, c as descriptionListSectionTitleStyles, a as descriptionListTermStyles, u as getDescriptionListStyles };

//# sourceMappingURL=style.js.map